import { render, staticRenderFns } from "./PagePositionTemplates.vue?vue&type=template&id=154ad4e4&"
import script from "./PagePositionTemplates.vue?vue&type=script&lang=js&"
export * from "./PagePositionTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports